import Image from 'next/image';
import { TeamPlaceholderMediumIcon } from './icons/teams/TeamPlaceholderMediumIcon';

type TeamLogoProps = {
  url?: string | null;
  className?: string;
  size: number;
  name: string | null | undefined;
};

export const TeamLogo = ({ url, className, size, name }: TeamLogoProps) => {
  return (
    <>
      {url ? (
        <Image
          alt={`${name} team logo`}
          className={className}
          height={size}
          src={url}
          width={size}
        />
      ) : (
        <TeamPlaceholderMediumIcon
          desc="Team logo placeholder icon"
          title="Team Logo"
        />
      )}
    </>
  );
};
